import React from 'react';
import { ReactTypeformEmbed } from 'react-typeform-embed';
import Button from '../Button/Button';
import css from '../SectionHero/SectionHero.module.css';

class Popup extends React.Component {
  constructor(props) {
    super(props);
    this.openForm = this.openForm.bind(this);
  }

  openForm() {
    this.typeformEmbed.typeform.open();
  }

  render() {
    return (
      <div>
        <ReactTypeformEmbed
          popup
          autoOpen={false}
          url="https://form.typeform.com/to/jogdXE2i"
          hideHeaders
          hideFooter
          style={{ top: 100 }}
          ref={tf => {
            this.typeformEmbed = tf;
          }}
        />
        <p>To get started, click your initials on the top right and click Get Started! If you have not signed up yet, create an account by clicking Log in on the top right.</p>
 
      </div>
    );
  }
}

export default Popup;
